/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $msg from './_msg'

export interface IInitOptions {
    pageName: string
    pageNameUnique: string
    pagePrefix: string
}

let options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    var clipboard = new ClipboardJS('.' + options.pageNameUnique + ' ul li a')

    clipboard.on('success', function (e: any) {
        e.clearSelection()

        $msg.show('Fastighetsbeteckning har kopierats till klippbordet! Du kan klistra in det direkt på sidan du kommer till.')

        var link = $(e.trigger).attr('data-link')

        setTimeout(function () {
            window.open('https://dereferer.me/?' + escape(link), 'maplinks', 'noreferrer,noopener')
        }, 1000)
    })

    clipboard.on('error', function (e: any) {
        $msg.showError('Kunde inte kopiera fastighetsbeteckning. Försök skriva in beteckning för hand på sidan du kommer till.')

        var link = $(e.trigger).attr('data-link')

        setTimeout(function () {
            window.open('https://dereferer.me/?' + escape(link), 'maplinks', 'noreferrer,noopener')
        }, 1000)
    })
}
